import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ApiError } from 'app/core/errors';
import { AuthService } from '../auth/auth.service';

/** HTTP Interceptor que manipula os erros dos request's HTTP retornados do server */
@Injectable({
    providedIn: 'root'
})
export class HttpErrorInterceptor implements HttpInterceptor {

    constructor(private authService: AuthService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(req)
            .pipe(
                catchError((httpError: HttpErrorResponse) => {
                    if (httpError.status === 401) { // Se for um erro de autenticação, voltamos a tela de login
                        this.authService.removeSession();
                    } else if (httpError.error instanceof ErrorEvent) { // Erro no client-side ou erro de internet
                        //
                    } else { // Outros erros do servidor
                        //
                    }

                    // Se existir o object do error
                    if (httpError && httpError.error) {
                        // Se for um Blob (Erros de relatório por exemplo) retornamos o próprio erro
                        if (httpError.error instanceof Blob) {
                            return throwError(httpError.error); // BlobError
                        } else { // Se não, criamos um ApiError
                            const apiError: ApiError = {
                                message: httpError.error.message,
                                cause: httpError.error.cause,
                                type: httpError.error.type,
                                status: httpError.status,
                                body: httpError.error
                            };
                            return throwError(apiError); // ApiError
                        }
                    }

                    return throwError(httpError); // HTTP Error Default
                })
            );
    }
}
